window.addEventListener('DOMContentLoaded', initLogos);

function initLogos() {
  document.querySelectorAll('body:not(.neos-backend) .c-logos').forEach((logos) => {
    const allLogos = logos.querySelectorAll('.c-logos .c-logos-content:not(.c-animated-row) .c-logo:not(.no-mask)');
    allLogos.forEach((logo) => {
      const img = logo.querySelector('img');
      if (img.src.toLowerCase().endsWith('.svg')) {
        const container = logo.querySelector('.c-image');
        container.classList.add('mask-bg');
        container.style.maskImage = 'url(' + img.src + ')';
        img.classList.add('mask');
      }
    });
    const row = logos.querySelector('.c-animated-row');
    if (!row) return;
    const clone = row.cloneNode(true);
    logos.appendChild(clone);
  });
}
